import { useCallback } from "react";
import { useIsDocumentSortAllowed } from "../role/useIsDocumentSortAllowed";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { fetchRequestListAction } from "../../redux/actions/request/list/requestList";
import { setDocumentSortCertificate, setDocumentSortDirection } from "../../redux/reducers/request/list/requestlist";

/**
 * Estado y wiring compartido de la "Ordenación de expedientes por Nº documento" (SISPOWEB),
 * reutilizado por SelectorTipoCertificado y OrdenNumeroDocumento en ambas variantes (popUp/pivot)
 * de la barra de filtros de solicitudes, para que cada control se integre como un ítem de filtro
 * más, con los mismos estilos que el resto (ver expedient.tsx de cada variante).
 */
export const useDocumentSortFilter = () => {
    const isAllowed = useIsDocumentSortAllowed();
    const dispatch = useAppDispatch();
    const { documentSort } = useAppSelector((state) => state.requestlist);

    const onCertificateChange = useCallback(
        (certificateTypeId: number | undefined) => {
            dispatch(setDocumentSortCertificate(certificateTypeId));
            dispatch(fetchRequestListAction(1));
        },
        [dispatch],
    );

    const onDirectionChange = useCallback(
        (direction: string) => {
            dispatch(setDocumentSortDirection(direction));
            dispatch(fetchRequestListAction(1));
        },
        [dispatch],
    );

    return { isAllowed, documentSort, onCertificateChange, onDirectionChange };
};
